import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { APIS } from '../../common/constants';
import {
  Role,
  Location,
  ControlPoint,
  InspectionLevel,
  ClientDecision,
  InspectionStatus,
  DefectResponse,
  Division,
  TenantCentre,
  Customer,
} from '../../models/meta.model';
import { SkipReason } from '../../shared/skipped-inspections/components/skipped-inspection/skipped-inspection.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  constructor(private httpService: HttpService) {}

  getLocations(): Observable<Location[]> {
    return this.httpService.getDataWithCache(APIS.META.LOCATIONS);
  }

  getTenantCentres(): Observable<TenantCentre[]> {
    return this.httpService.getDataWithCache(APIS.META.TENANT_CENTRES);
  }

  getRoles(): Observable<Role[]> {
    return this.httpService.getDataWithCache(APIS.META.ROLES);
  }

  getControlPoints(): Observable<ControlPoint[]> {
    return this.httpService.getDataWithCache(APIS.META.CONTROL_POINTS);
  }

  getDivisions(customerId?: string): Observable<Division[]> {
    if (customerId) {
      // Customer-scoped divisions bypass the tenant-wide cache so we always
      // see the divisions the picked customer owns.
      return this.httpService.getData(APIS.META.DIVISIONS, { customerId });
    }
    return this.httpService.getDataWithCache(APIS.META.DIVISIONS);
  }

  getSkipReasons(): Observable<SkipReason[]> {
    return this.httpService.getDataWithCache(APIS.META.SKIP_REASONS);
  }

  getInspectionStatuses(): Observable<InspectionStatus[]> {
    return this.httpService.getDataWithCache(APIS.META.INSPECTION_STATUSES);
  }

  getDefectsAndSeverities(
    filterKey: string | null = null,
    filterVal: string | null = null
  ): Observable<DefectResponse> {
    return filterKey
      ? this.httpService.getData(APIS.META.DEFECTS_AND_SEVERITIES, { [filterKey]: filterVal })
      : this.httpService.getDataWithCache(APIS.META.DEFECTS_AND_SEVERITIES);
  }

  getInspectionLevels(): Observable<InspectionLevel[]> {
    return this.httpService
      .getDataWithCache(APIS.META.INSPECTION_LEVELS)
      .pipe(map((levels: InspectionLevel[]) => levels.sort((a, b) => a.value - b.value)));
  }

  getInspectionResults(): Observable<string[]> {
    return this.httpService.getDataWithCache(APIS.META.INSPECTION_RESULTS);
  }

  getClientDecisions(): Observable<ClientDecision[]> {
    return this.httpService.getDataWithCache(APIS.META.CLIENT_DECISIONS);
  }

  getCustomers(): Observable<Customer[]> {
    return this.httpService.getDataWithCache(APIS.COMMON.CUSTOMERS);
  }
}
